import React, { useEffect, useState } from "react";
import "../style/LatestUserReviews.css";

const reviews = [
  {
    id: 1,
    rating: 4.8,
    text: "The 2026 Toyota Land Cruiser hybrid is a game-changer for off-road enthusiasts. The new 23 MPG combined rating and standard Level 2 ADAS safety suite make it the best reliable SUV for families who still want rugged adventure.",
    name: "Vishal Rajput",
    initials: "VR"
  },
  {
    id: 2,
    rating: 4.6,
    text: "After testing the Maruti Suzuki eVitara, I’m convinced affordable EVs have finally arrived. The 500km range on a single charge and the dual-screen infotainment system offer premium value that competes directly with luxury electric models.",
    name: "Prakhar Shukla",
    initials: "PS"
  },
  {
    id: 3,
    rating: 4.9,
    text: "The 2026 BMW 5 Series sets a new benchmark for executive sedans. The integration of AI-powered voice assistants and the whisper-quiet diesel-hybrid engine provides a driving experience that is both sustainable and incredibly plush.",
    name: "Sameer Akthar",
    initials: "SA"
  },
];

const LatestUserReviews = () => {
  const [active, setActive] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setActive((prev) => (prev + 1) % reviews.length);
    }, 4500);
    return () => clearInterval(interval);
  }, []);

  return (
    <section className="reviews-premium-section">
      <div className="reviews-header-block">
        <span className="reviews-eyebrow">Community Pulse</span>
        <h2 className="reviews-main-title">Latest User Reviews</h2>
        <p className="reviews-subtitle">Real feedback from our driving community.</p>
      </div>

      <div className="reviews-display-grid">
        {reviews.map((rev, index) => (
          <div 
            key={rev.id} 
            className={`review-glass-card ${index === active ? "active-focus" : ""}`}
          >
            <div className="review-card-header">
              <div className="user-avatar-circle">{rev.initials}</div>
              <div className="rating-pill">
                <span className="star-icon">★</span> {rev.rating}
              </div>
            </div>

            <div className="review-body">
              <span className="large-quote">“</span>
              <p className="review-main-text">{rev.text}</p>
            </div>

            <div className="review-footer-info">
              <h4 className="reviewer-name">{rev.name}</h4>
              <span className="verified-tag">Verified Owner</span>
            </div>
          </div>
        ))}
      </div>
      
      <div className="review-indicators">
        {reviews.map((_, i) => (
          <div key={i} className={`dot ${i === active ? "active-dot" : ""}`} />
        ))}
      </div>
    </section>
  );
};

export default LatestUserReviews;